export const DEFAULT_FONT_SIZE_PX = {
  h1: 42,
  h2: 37,
  h3: 32,
  h4: 27,
  h5: 22,
  h6: 17,
  body1: 15,
  body2: 12,
  caption: 10,
} as const;

export type TypographyVariant = keyof typeof DEFAULT_FONT_SIZE_PX;
